import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit, Renderer2 } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Observable, Subject, Subscription } from 'rxjs';
import { ProductData } from '../../../../../core/model/Product.model';
import { EventService } from '../../../../../services/event.service';
import { ArticulosGuardadosService } from '../../../../../services/generar-pedido/cart/articulos-guardados.service';
import { CartService } from '../../../../../services/generar-pedido/cart/cart.service';
import { LoginService } from '../../../../../services/login/login.service';
import { HeightCartService } from '../utils/services/height-cart.service';
import { takeUntil } from 'rxjs/operators';
import { DialogConfirmComponent } from '../dialog-confirm/dialog-confirm.component';
import { EmpresaService } from '../../../../../services/Empresa/Empresa.service';
import { CheckoutService } from '../utils/services/checkout.service';

@Component({
  selector: 'app-list-product-cart',
  templateUrl: './list-product-cart.component.html',
  styleUrls: ['./list-product-cart.component.scss']
})
export class ListProductCartComponent implements OnInit {
  public listProducts$: Observable<ProductData[]>;
  public kabikCoins$: Observable<number>;
  public selection: SelectionModel<ProductData>;
  public labelPosition = 'before'; // Posicion del texto del checkbox .
  public kabikCoin: number = 0; // Puntos Kabikcoin.
  public disabled: boolean; // Desabilita el check del
  public IsChecked: boolean;
  public formCart: FormGroup;
  public loading = true;
  public clave: string;
  public isCedis: boolean;
  public boton$: Observable<boolean>;
  public claveDelete: string;
  public ocultare: boolean = true;
  public suscription: Subscription = null;
  public width: number = 0;
  private unsubscribe$ = new Subject<void>();
  defaultImg: string = '../../../../../../assets/not_found_image.png';
  receivedData: any;
  flagKabikCoin = false;

  empresaId: number;
  
  constructor(
    private cartService: CartService,
    private router: Router,
    private login: LoginService,
    private fb: FormBuilder,
    private eventService: EventService,
    private articuloGuardadosService: ArticulosGuardadosService,
    private dialogConfirm: MatDialog,
    private renderer: Renderer2,
    private sharedService: HeightCartService,
    private empresaService: EmpresaService,
    private checkoutService: CheckoutService,
  ) { }

  addStyleToElement() {
    const element = document.querySelector('.dump-all');
    this.renderer.setStyle(element, 'top', '18px');
  }

  ngOnDestroy(): void {
    if (this.suscription) {
      this.suscription.unsubscribe();
      this.suscription = null;
    }
  }

  ngOnInit(): void {
    this.empresaId = this.empresaService.getEmpresaId();
    this.width = window.innerWidth;
    this.suscription = this.eventService.get("hidden").subscribe((data) => {
      this.ocultare = data.data;
    });
    this.boton$ = this.cartService.continuarCart;
    this.listProducts$ = this.cartService.cart$;
    this.selection = new SelectionModel<ProductData>(true, []);
    this.form();
    // ESTE SERVICIO ES PARA EL SALDO VENCIDO DEL CREDITO. LA FUENTE VIENE DE 'tipo-compra.component.ts'
    this.sharedService.getData().subscribe((data) => {
      this.receivedData = data;
      // console.log(this.receivedData,"?!?!wqd$$$$!dwqdq")
      if (this.receivedData !== null && this.receivedData <= 0) {
        // console.log("WHAAAAAAAAAAAAAAAAAAAAAAAAAT", this.flagKabikCoin);
        this.flagKabikCoin = true;
        // console.log("WHEREEEEEEEEEEEEEEEEEEEEEEEE", this.flagKabikCoin);
      }
    });
  }

  public form = () => {
    this.formCart = this.fb.group({
      checkBox: [''],
    });
  }

  /**
   * Metodo para actualizar la cantidad del articulo de la lista del carrito
   * @param event parametro que recibe la nueva cantidad que se le añadira al articulo
   * @param item parametro que contiene los datos del articulo, para poder hacer un recorrido y actualizar el corrector
   * Este metodo hace dos acciones dependiendo si el usuario esta logueado
   * Si esta logueado entonces actualiza de la variable global @cart ---
   * ----> y hace una petición a al api para actualizar tambíen en la tabla de la @DB
   * Si no esta logueado solo actualiza de la variable global @cart
   */
  public getCantidad = (event: any, item: ProductData): void => {
    // // console.log('Cantidad de veces que entro esta funcin');
    this.cartService.continuarCart.emit(true);
    this.clave = item.ClaveArticuloProveedor;
    this.isCedis = item.isCedis;
    this.loading = true;
    const data = {
      qty: event.cantidad,
      IsCedis: event.cedis,
      ClaveArticuloProveedor: item.ClaveArticuloProveedor,
      AlmacenID: item.AlmacenID,

    };
    if (this.login.isLogged()) {
      // console.log('data = >', data);
      // console.log('item = >', item)
      this.cartService
        .updateCartItemsQty(data, item)
        .subscribe((responseData) => {
          this.loading = false;
          this.clave = '';
          this.isCedis = false;
          this.cartService.continuarCart.emit(false);
          this.checkoutService.itemsOrder();
          // this.deselect(item);
        });
    } else {
      this.cartService.updateCartItemsQtyInvite(data, item);
      this.loading = false;
      this.clave = '';
      this.isCedis = false;
      this.cartService.continuarCart.emit(false);
    }
  };
  
  /**
   * Metodo para eliminar el item (Articulo) de la lista del carrito
   * @param itemProduct item el cual se va a eliminar
   * @param listProducts la lista de articulos las cuales ya estan en el carrito
   * Este metodo hace dos acciones dependiendo si el usuario esta logueado
   * Si esta logueado entonces elimina de la variable global @cart y hace una petición a al api para eliminar tambíen en la tabla de la @DB
   * si no esta logueado solo elimina de la variable global @cart
   */
  public deleteItem = (
    itemProduct: ProductData,
    listProducts: ProductData[]
  ): void => {
    // console.log("w",itemProduct)
    // console.log("w",listProducts)
    this.cartService.continuarCart.emit(true); // desabilita el boton de continuar Cart
    this.claveDelete = itemProduct.ClaveArticulo;
    this.isCedis = itemProduct.isCedis;
    if (this.login.isLogged()) {
      this.cartService.removeItemToCart(itemProduct).subscribe(() => {
        this.claveDelete = '';
        this.isCedis = false;
        this.cartService.continuarCart.emit(false);
        // console.log(this.checkout.itemsOrder(), "SALABALA")
        this.checkoutService.itemsOrder();
        /* if (listProducts.length <= 1) {
          this.router.navigate(['/']);
        } */
      });
    } else {
      this.cartService.deleteItemToCartInvite(itemProduct);
      this.claveDelete = '';
      this.isCedis = false;
      this.cartService.continuarCart.emit(false);
      /* if (listProducts.length <= 1) {
        this.router.navigate(['/']);
      } */
    }
  };

  public selected(event?: any, row?: ProductData) {
    this.cartService.continuarCart.emit(true);
    if (event.checked) {
      this.cartService.CheckKabikCoin(row, true);
    } else {
      this.cartService.CheckKabikCoin(row, false);
    }
    event = event ? this.selection.toggle(row) : null;
    this.cartService.continuarCart.emit(false);
  }

  public GuardarParaMasTarde(item?: ProductData): void {
    const existencias = item.isCedis ? item.ExistenciasCedis : item.ExistenciasSucursal;
    if (item.CANT_CAR <= existencias) {
      const dataArticulo: any = {
        ClaveArticulo: item.ClaveArticuloProveedor,
        Cantidad: item.CANT_CAR,
        AlmacenID: 1,
        isCedis: item.isCedis
      };
      this.articuloGuardadosService.addNewItemArt(dataArticulo, item).subscribe(res => {
        if (!res.error) {
          if (this.login.isLogged()) {
            this.cartService.removeItemToCart(item).subscribe(() => {
              this.claveDelete = '';
              this.isCedis = item.isCedis;
              this.cartService.continuarCart.emit(false);
              this.articuloGuardadosService.getArticulosGuardados().subscribe(res => {
                console.log('line 175', res);
              });
            });
          }
        }
      });
    }
  }

  /**Change size view */
  onResize(event: any) {
    this.width = event.target.innerWidth;
    if (this.width > 876) {
      //this.router.navigate(["/"]);
    }
  }

  public deleteCart = () => {
    const dialogRes = this.dialogConfirm.open(DialogConfirmComponent, {
      // width: '55vh',
      data: {
        title: '¿Estas seguro que deseas vaciar tu cesta?',
        text: '',
        subtext: '',
        btnPrimaryText: 'Sí, Vaciar',
        btnSecondText: 'No, Cancelar',
        classCancelSecond: true,
        classbtnSecond: true,
        showCancel: true,
        classCustomText: ''
      }
    });
    dialogRes.afterClosed().pipe(
      takeUntil(this.unsubscribe$)
    ).subscribe(response => {
      if (response) {
        if (this.login.isLogged()) {
          this.cartService.deleteCart();
          this.checkoutService.itemsOrder();
        } else {
          this.cartService.deleteCartIsNotLoguin(); //vaciar cesta cuano no ha iniciado session
        }
        localStorage.removeItem('resumen-cart-login');
        localStorage.removeItem('data-pedido');
        localStorage.removeItem('carrito');
        localStorage.removeItem('items-cart-login');
        localStorage.removeItem('comision-cart-login');
        localStorage.removeItem('pasarela-pago');
        localStorage.removeItem('envio-cart-login');
        localStorage.removeItem('data-operation');
      }
    });
  }

   getCurrentImg(itemProduct: any): string {
    const index = itemProduct.currentImgIndex ?? 0;
    return itemProduct.Img_list?.[index] || this.defaultImg;
  }

  handleImgError(itemProduct: any) {
    if (itemProduct.currentImgIndex === undefined) {
      itemProduct.currentImgIndex = 0;
    }

    if (itemProduct.currentImgIndex < itemProduct.Img_list.length - 1) {
      itemProduct.currentImgIndex++; // Intenta con la siguiente imagen
    } else {
      console.log('No se encontró ninguna imagen válida para', itemProduct.ClaveArticuloProveedor);
      itemProduct.currentImgIndex = -1; // Apunta a imagen por defecto
    }
  }
}
